import { Storage } from '@yoummday/ymmd-client-storage';
import { Log } from '@yoummday/ymmd-logger';
import {
	internationalization as i18nCore,
	type Internationalization,
	type Override,
} from '@yoummday/ymmd-platform-core';
import txtJsonShape from './en.json';

const i18n: Override<
	Internationalization,
	{
		rawText: typeof txtJsonShape | null;
		txt: typeof txtJsonShape | null;
	}
> = {
	...i18nCore,
	Log,
	storage: new Storage(`${import.meta.env.VITE_APPVERSION}_i18n`),
	sourceFiles: import.meta.glob('./{de,en}.json', {
		import: 'default',
	}),
	rawText: txtJsonShape,
	txt: txtJsonShape,
};

export { i18n };
